module.exports = "https://coinrabbit.io/_next/static/images/g2-icon-fbfde70cd1f9cc4d0792f5408fad8dd1.jpeg";